module.exports = __webpack_public_path__ + "img/pro-photo5.b548f44f.png";